module.exports = __webpack_public_path__ + "04_hair_gold.e3a7b440.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/04_hair_gold.png
// module id = e8a6
// module chunks = 0